/**
 * @generated SignedSource<<4fc3db4e8903bdedfa503989ea149947>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isAnswerBase"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fieldName",
  "storageKey": null
},
v4 = [
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "FormFieldOptionChoice",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "values",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "other",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "formField",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v3/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "required",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hint",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hintPosition",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hide",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readOnly",
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "autoComplete",
    "storageKey": null
  }
],
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v16/*: any*/),
          "type": "FormFieldString",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerString",
  "abstractKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v16/*: any*/),
          "type": "FormFieldText",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerText",
  "abstractKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentAttachmentToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "FormFieldAuthorizations",
          "kind": "LinkedField",
          "name": "authorizations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displaySimilarContributionsSuggestions",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerRichText",
  "abstractKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourcesAttachmentToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Attachment",
      "kind": "LinkedField",
      "name": "sources",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        (v20/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "multiple",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxFiles",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowedFileExtensions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maximumFileSize",
              "storageKey": null
            }
          ],
          "type": "FormFieldFile",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerFile",
  "abstractKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "otherValue",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayOtherField",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "otherFieldLabel",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singleOptionSelection",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maximumSelectableOptions",
  "storageKey": null
},
v27 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v23/*: any*/),
            (v24/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "selectableType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FormFieldOptionChoice",
              "kind": "LinkedField",
              "name": "listedOptions",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                (v20/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isCorrect",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correctionText",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "optionsSearchable",
              "storageKey": null
            }
          ],
          "type": "FormFieldCheckBoxes",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormFieldOptionChoice",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v20/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerCheckBoxes",
  "abstractKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    (v2/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AnswerWeightedOption",
      "kind": "LinkedField",
      "name": "dispatchedBudgetValues",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "optionId",
          "storageKey": null
        },
        (v28/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "budget",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maxBudgetPerOption",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minBudgetToSpend",
              "storageKey": null
            },
            (v29/*: any*/)
          ],
          "type": "FormFieldBudgetDispatcher",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerBudgetDispatcher",
  "abstractKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selectedThemeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maximumThemes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FormFieldThemeOption",
              "kind": "LinkedField",
              "name": "themes",
              "plural": true,
              "selections": [
                (v10/*: any*/),
                (v28/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormFieldThemeOption",
                  "kind": "LinkedField",
                  "name": "children",
                  "plural": true,
                  "selections": [
                    (v10/*: any*/),
                    (v28/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FormFieldThemeOption",
                      "kind": "LinkedField",
                      "name": "children",
                      "plural": true,
                      "selections": [
                        (v10/*: any*/),
                        (v28/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FormFieldThemeOption",
                          "kind": "LinkedField",
                          "name": "children",
                          "plural": true,
                          "selections": [
                            (v10/*: any*/),
                            (v28/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FormFieldThemeOption",
                              "kind": "LinkedField",
                              "name": "children",
                              "plural": true,
                              "selections": [
                                (v10/*: any*/),
                                (v28/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "FormFieldThemeOption",
                                  "kind": "LinkedField",
                                  "name": "children",
                                  "plural": true,
                                  "selections": [
                                    (v10/*: any*/),
                                    (v28/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "FormFieldThemeOption",
                                      "kind": "LinkedField",
                                      "name": "children",
                                      "plural": true,
                                      "selections": [
                                        (v10/*: any*/),
                                        (v28/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "FormFieldThemeOption",
                                          "kind": "LinkedField",
                                          "name": "children",
                                          "plural": true,
                                          "selections": [
                                            (v10/*: any*/),
                                            (v28/*: any*/),
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "FormFieldThemeOption",
                                              "kind": "LinkedField",
                                              "name": "children",
                                              "plural": true,
                                              "selections": [
                                                (v10/*: any*/),
                                                (v28/*: any*/),
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "concreteType": "FormFieldThemeOption",
                                                  "kind": "LinkedField",
                                                  "name": "children",
                                                  "plural": true,
                                                  "selections": [
                                                    (v10/*: any*/),
                                                    (v28/*: any*/),
                                                    {
                                                      "alias": null,
                                                      "args": null,
                                                      "concreteType": "FormFieldThemeOption",
                                                      "kind": "LinkedField",
                                                      "name": "children",
                                                      "plural": true,
                                                      "selections": [
                                                        (v10/*: any*/),
                                                        (v28/*: any*/),
                                                        (v2/*: any*/)
                                                      ],
                                                      "storageKey": null
                                                    },
                                                    (v2/*: any*/)
                                                  ],
                                                  "storageKey": null
                                                },
                                                (v2/*: any*/)
                                              ],
                                              "storageKey": null
                                            },
                                            (v2/*: any*/)
                                          ],
                                          "storageKey": null
                                        },
                                        (v2/*: any*/)
                                      ],
                                      "storageKey": null
                                    },
                                    (v2/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v2/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v2/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v2/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                },
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "FormFieldThemes",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerThemes",
  "abstractKey": null
},
v32 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "none",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maximumEvents",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowNone",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "options",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": "name",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "FormFieldEvents",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerEvents",
  "abstractKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "consentGiven",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayEmailConsent",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "consentLabel",
              "storageKey": null
            }
          ],
          "type": "FormFieldEmailWithConsents",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerEmailWithConsents",
  "abstractKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OralInterviewMessage",
      "kind": "LinkedField",
      "name": "messages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "role",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v14/*: any*/),
        (v12/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "closingMessage",
              "storageKey": null
            }
          ],
          "type": "FormFieldOralInterview",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "individualSummary",
      "storageKey": null
    }
  ],
  "type": "AnswerOralInterview",
  "abstractKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v36 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minimumSelectableOptions",
              "storageKey": null
            },
            (v26/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "options",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v2/*: any*/),
                (v20/*: any*/),
                (v35/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "FormFieldSortableList",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerSortableList",
  "abstractKey": null
},
v37 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AnswerItemOption",
      "kind": "LinkedField",
      "name": "itemOptions",
      "plural": true,
      "selections": [
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "FormFieldItem",
          "kind": "LinkedField",
          "name": "item",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        (v5/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v26/*: any*/),
            (v25/*: any*/),
            (v23/*: any*/),
            (v24/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "FormFieldItem",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                (v10/*: any*/)
              ],
              "storageKey": null
            },
            (v29/*: any*/)
          ],
          "type": "FormFieldMatrix",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerMatrix",
  "abstractKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        (v10/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerPresentationTitle",
  "abstractKey": null
},
v39 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v9/*: any*/)
          ],
          "type": "FormFieldPresentationTextZone",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerPresentationTextZone",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SignUpAppRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationConfig",
        "kind": "LinkedField",
        "name": "authenticationConfig",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AuthenticationSignUp_authenticationConfig"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SignUpAppRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationConfig",
        "kind": "LinkedField",
        "name": "authenticationConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "privacyPolicyPageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailConfirmationRequired",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableEmailConsent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailConsentLabel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormResponse",
            "kind": "LinkedField",
            "name": "userSubscriptionFormResponse",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "answers",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSeparator",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "formField",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormFieldDisplayCondition",
                        "kind": "LinkedField",
                        "name": "displayConditions",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "formFieldName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormFieldDisplayConditionOption",
                            "kind": "LinkedField",
                            "name": "conditionOptions",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "otherOption",
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "displayConditionAnswers",
                    "plural": true,
                    "selections": [
                      (v0/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v21/*: any*/),
                  (v27/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "answers",
                        "plural": true,
                        "selections": [
                          (v0/*: any*/),
                          (v2/*: any*/),
                          (v8/*: any*/),
                          (v1/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v21/*: any*/),
                          (v27/*: any*/),
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/),
                          (v39/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerAddress",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "formField",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "goal",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unit",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "minAmount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "maxAmount",
                                "storageKey": null
                              }
                            ],
                            "type": "FormFieldBudget",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AnswerBudgetChapter",
                        "kind": "LinkedField",
                        "name": "answers",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "formField",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              (v3/*: any*/),
                              (v2/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FormFieldOptionBudgetLine",
                                    "kind": "LinkedField",
                                    "name": "budgetLines",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v20/*: any*/),
                                      (v28/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "withOptions",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "displayMode",
                                        "storageKey": null
                                      },
                                      (v26/*: any*/),
                                      (v35/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BudgetLineOption",
                                        "kind": "LinkedField",
                                        "name": "budgetLineOptions",
                                        "plural": true,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v10/*: any*/),
                                          (v28/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "position",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "FormFieldBudgetChapter",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AnswerBudget",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "36e7aef58521505b377d00624e733388",
    "id": null,
    "metadata": {},
    "name": "SignUpAppRouteQuery",
    "operationKind": "query",
    "text": "query SignUpAppRouteQuery {\n  authenticationConfig {\n    ...AuthenticationSignUp_authenticationConfig\n    id\n  }\n}\n\nfragment AnswerAddress_answer on AnswerAddress {\n  formField {\n    __typename\n    id\n    fieldName\n    hide\n  }\n  answers {\n    __typename\n    id\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    ...ShallowAnswer_answer\n  }\n}\n\nfragment AnswerBudgetChapter_answer on AnswerBudgetChapter {\n  values\n  formField {\n    __typename\n    fieldName\n    label\n    required\n    hint\n    hintPosition\n    hide\n    ... on FormFieldBudgetChapter {\n      budgetLines {\n        id\n        name\n        value\n        withOptions\n        displayMode\n        maximumSelectableOptions\n        description\n        budgetLineOptions {\n          id\n          label\n          value\n          position\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AnswerBudgetDispatcher_answer on AnswerBudgetDispatcher {\n  id\n  dispatchedBudgetValues {\n    optionId\n    value\n    id\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldBudgetDispatcher {\n      budget\n      maxBudgetPerOption\n      minBudgetToSpend\n      options {\n        __typename\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment AnswerBudget_answer on AnswerBudget {\n  formField {\n    __typename\n    fieldName\n    label\n    required\n    hint\n    hintPosition\n    hide\n    ... on FormFieldBudget {\n      goal\n      unit\n      minAmount\n      maxAmount\n    }\n    id\n  }\n  answers {\n    id\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    ...AnswerBudgetChapter_answer\n  }\n}\n\nfragment AnswerCheckBoxes_answer on AnswerCheckBoxes {\n  values\n  other\n  otherValue\n  formField {\n    __typename\n    id\n    fieldName\n    label\n    required\n    hint\n    hintPosition\n    hide\n    ... on FormFieldCheckBoxes {\n      displayOtherField\n      otherFieldLabel\n      singleOptionSelection\n      maximumSelectableOptions\n      selectableType\n      listedOptions {\n        id\n        name\n        isCorrect\n        correctionText\n      }\n    }\n  }\n  ...FormFieldOptionsSelect_answer\n}\n\nfragment AnswerEmailWithConsents_answer on AnswerEmailWithConsents {\n  id\n  content\n  consentGiven\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldEmailWithConsents {\n      displayEmailConsent\n      consentLabel\n    }\n  }\n}\n\nfragment AnswerEvents_answer on AnswerEvents {\n  id\n  eventIds\n  none\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldEvents {\n      maximumEvents\n      allowNone\n      options {\n        id\n        name: title\n      }\n    }\n  }\n}\n\nfragment AnswerFile_answer on AnswerFile {\n  sourcesAttachmentToken\n  sources {\n    key\n    name\n    url\n    id\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldFile {\n      multiple\n      maxFiles\n      allowedFileExtensions\n      maximumFileSize\n    }\n  }\n}\n\nfragment AnswerMatrix_answer on AnswerMatrix {\n  id\n  other\n  otherValue\n  itemOptions {\n    other\n    item {\n      id\n    }\n    option {\n      id\n    }\n    id\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldMatrix {\n      maximumSelectableOptions\n      singleOptionSelection\n      displayOtherField\n      otherFieldLabel\n      items {\n        id\n        label\n      }\n      options {\n        __typename\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment AnswerOralInterview_answer on AnswerOralInterview {\n  content\n  status\n  messages {\n    role\n    text\n  }\n  formField {\n    __typename\n    id\n    label\n    required\n    fieldName\n    hide\n  }\n  ...InterviewChatSection_answer\n  ...InterviewCompletionSection_answer\n  ...InterviewControlsSection_answer\n  ...InterviewIntroSection_answer\n  ...InterviewResponseSection_answer\n}\n\nfragment AnswerPresentationTextZone_answer on AnswerPresentationTextZone {\n  formField {\n    __typename\n    ... on FormFieldPresentationTextZone {\n      content\n    }\n    id\n  }\n}\n\nfragment AnswerPresentationTitle_answer on AnswerPresentationTitle {\n  formField {\n    __typename\n    label\n    id\n  }\n}\n\nfragment AnswerRichText_answer on AnswerRichText {\n  id\n  content\n  contentAttachmentToken\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    readOnly\n    id\n  }\n  ...SimilarAnswersSuggestions_answer\n}\n\nfragment AnswerSortableList_answer on AnswerSortableList {\n  id\n  values\n  formField {\n    __typename\n    id\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldSortableList {\n      minimumSelectableOptions\n      maximumSelectableOptions\n      options {\n        __typename\n        id\n        name\n        description\n      }\n    }\n  }\n}\n\nfragment AnswerString_answer on AnswerString {\n  content\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    readOnly\n    ... on FormFieldString {\n      autoComplete\n    }\n    id\n  }\n}\n\nfragment AnswerText_answer on AnswerText {\n  content\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    readOnly\n    ... on FormFieldText {\n      autoComplete\n    }\n    id\n  }\n}\n\nfragment AnswerThemes_answer on AnswerThemes {\n  selectedThemeIds\n  formField {\n    __typename\n    label\n    required\n    hint\n    hintPosition\n    fieldName\n    hide\n    ... on FormFieldThemes {\n      maximumThemes\n      themes {\n        label\n        value\n        children {\n          label\n          value\n          children {\n            label\n            value\n            children {\n              label\n              value\n              children {\n                label\n                value\n                children {\n                  label\n                  value\n                  children {\n                    label\n                    value\n                    children {\n                      label\n                      value\n                      children {\n                        label\n                        value\n                        children {\n                          label\n                          value\n                          children {\n                            label\n                            value\n                            id\n                          }\n                          id\n                        }\n                        id\n                      }\n                      id\n                    }\n                    id\n                  }\n                  id\n                }\n                id\n              }\n              id\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment Answer_answer on AnswerBase {\n  __isAnswerBase: __typename\n  __typename\n  ...ShallowAnswer_answer\n  ...AnswerAddress_answer\n  ...AnswerBudget_answer\n  ...useAnswerShouldBeConditionnallyHidden_answer\n}\n\nfragment Answers_answers on AnswerBase {\n  __isAnswerBase: __typename\n  id\n  isSeparator\n  ...Answer_answer\n  ...useFilterConditionnallyHiddenAnswers_answers\n}\n\nfragment AuthenticationSignUp_authenticationConfig on AuthenticationConfig {\n  privacyPolicyPageUrl\n  emailConfirmationRequired\n  enableEmailConsent\n  emailConsentLabel\n  userSubscriptionFormResponse {\n    answers {\n      __typename\n      ...Answers_answers\n      id\n    }\n    id\n  }\n}\n\nfragment FormFieldOptionsSelect_answer on AnswerCheckBoxes {\n  selectedOptions {\n    id\n    name\n  }\n  formField {\n    __typename\n    id\n    ... on FormFieldCheckBoxes {\n      optionsSearchable\n    }\n  }\n}\n\nfragment InterviewChatMessage_message on OralInterviewMessage {\n  role\n  text\n}\n\nfragment InterviewChatSection_answer on AnswerOralInterview {\n  messages {\n    ...InterviewChatMessage_message\n  }\n}\n\nfragment InterviewCompletionSection_answer on AnswerOralInterview {\n  individualSummary\n  formField {\n    __typename\n    ... on FormFieldOralInterview {\n      closingMessage\n    }\n    id\n  }\n}\n\nfragment InterviewControlsSection_answer on AnswerOralInterview {\n  status\n  messages {\n    role\n    text\n  }\n  formField {\n    __typename\n    id\n    required\n  }\n}\n\nfragment InterviewIntroSection_answer on AnswerOralInterview {\n  formField {\n    __typename\n    hint\n    id\n  }\n}\n\nfragment InterviewResponseSection_answer on AnswerOralInterview {\n  status\n  formField {\n    __typename\n    id\n  }\n}\n\nfragment ShallowAnswer_answer on AnswerBase {\n  __isAnswerBase: __typename\n  __typename\n  ...AnswerString_answer\n  ...AnswerText_answer\n  ...AnswerRichText_answer\n  ...AnswerFile_answer\n  ...AnswerCheckBoxes_answer\n  ...AnswerBudgetDispatcher_answer\n  ...AnswerThemes_answer\n  ...AnswerEvents_answer\n  ...AnswerEmailWithConsents_answer\n  ...AnswerOralInterview_answer\n  ...AnswerSortableList_answer\n  ...AnswerMatrix_answer\n  ...AnswerPresentationTitle_answer\n  ...AnswerPresentationTextZone_answer\n}\n\nfragment SimilarAnswersSuggestions_answer on AnswerRichText {\n  ...useSimilarAnswers_answer\n}\n\nfragment useAnswerShouldBeConditionnallyHidden_answer on AnswerBase {\n  __isAnswerBase: __typename\n  formField {\n    __typename\n    fieldName\n    displayConditions {\n      formFieldName\n      conditionOptions {\n        otherOption\n        option {\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  displayConditionAnswers {\n    __typename\n    values\n    other\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    id\n  }\n}\n\nfragment useFilterConditionnallyHiddenAnswers_answers on AnswerBase {\n  __isAnswerBase: __typename\n  id\n  formField {\n    __typename\n    fieldName\n    displayConditions {\n      formFieldName\n      conditionOptions {\n        otherOption\n        option {\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  displayConditionAnswers {\n    __typename\n    values\n    other\n    formField {\n      __typename\n      fieldName\n      id\n    }\n    id\n  }\n}\n\nfragment useSimilarAnswers_answer on AnswerRichText {\n  id\n  formField {\n    __typename\n    id\n    authorizations {\n      displaySimilarContributionsSuggestions\n    }\n  }\n}\n"
  }
};
})();

node.hash = "ff93a0a6d538df6f57b5d9c4a99f55da";

module.exports = node;
